import { routeGuard } from "../../../router/guard";

export default [
  {
    path: "/homologacao",
    name: "Homologacao",
    component: () => import("../../Homologacao/HomologacaoView.vue"),
	},
	{
    path: "/homologacaonovo",
    name: "HomologacaoNovo",
    component: () => import("../../Homologacao/views/HomologacaoNovo.vue"),
  },
];
